import React from 'react';
import './About.css';

const team = [
  {
    name: 'Sudhanshu Singh',
    role: 'Founder & CEO',
    image: 'https://randomuser.me/api/portraits/men/32.jpg',
  },
  {
    name: 'Vijay Laxmi',
    role: 'Head of Academics',
    image: 'https://randomuser.me/api/portraits/women/44.jpg',
  },
  {
    name: 'Sudhanshu Mishra',
    role: 'Lead Data Scientist',
    image: 'https://randomuser.me/api/portraits/men/65.jpg',
  },
];

const About = () => (
  <div className="about">
    <section className="about-hero">
      <h1>About LetsCodeBrain</h1>
      <p>Empowering learners to achieve their dreams through affordable, high-quality education and expert mentorship.</p>
    </section>

    <section className="about-content">
      <div className="mission-vision">
        <div className="mission">
          <i className="fas fa-bullseye mission-icon" aria-hidden="true"></i>
          <h2>Our Mission</h2>
          <p>To make world-class education accessible and affordable for everyone, everywhere. We believe in personalized learning, hands-on experience, and continuous support to help our students succeed.</p>
        </div>
        <div className="vision">
          <i className="fas fa-eye vision-icon" aria-hidden="true"></i>
          <h2>Our Vision</h2>
          <p>To be the leading platform for upskilling and career transformation, recognized for our commitment to student success and innovation in education.</p>
        </div>
      </div>

      <section className="team-section">
        <h2>Meet Our Team</h2>
        <div className="team-grid">
          {team.map(member => (
            <div className="team-member" key={member.name}>
              <div className="member-image">
                <img src={member.image} alt={member.name} />
              </div>
              <h3>{member.name}</h3>
              <p>{member.role}</p>
            </div>
          ))}
        </div>
      </section>
    </section>
  </div>
);

export default About; 